import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary as MuiAccordionSummary,
    AccordionSummaryProps as MuiAccordionSummaryProps,
    Typography
} from "@mui/material";
import React, {useState} from "react";
import {styled} from "@mui/material/styles";
import {ApiService} from "../api/ApiService";

const AccordionSummary = styled((props: MuiAccordionSummaryProps) => (
        <MuiAccordionSummary expandIcon={<ExpandMoreIcon/>} {...props}
                             className={"accordionHeightStatic"} sx={{backgroundColor: "#036aaa", color: "white"}}
        />
))(({theme}) => ({
    backgroundColor: theme.palette.primary.light,
    color: "white",
}));

interface PresetComponentProps {
    children: React.ReactNode
    title: string
    id: string
    isAccordion: boolean
    isCollapsed: boolean
    presetId: number
    partyId: number
    error?: boolean
}

const PresetComponent = ({
                             children,
                             title,
                             id,
                             isAccordion,
                             isCollapsed,
                             presetId,
                             partyId,
                             error
                         }: PresetComponentProps) => {
    const [expanded, setExpanded] = useState(!isCollapsed);

    const onExpanded = () => {
        ApiService.Collapse(expanded, partyId, presetId);
        setExpanded(!expanded);
    }

    if (isAccordion) {
        return (
                <>
                    <Accordion id={id} expanded={expanded}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{color: "white"}}/>}
                                          sx={{minHeight: "48px !important;"}}
                                          onClick={onExpanded}>
                            <Typography variant="h6" sx={{color: (error ? "red" : "white")}}>
                                {title}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {children}
                        </AccordionDetails>
                    </Accordion>
                </>
        )
    }
    return children;
}

export default PresetComponent;